export default __webpack_public_path__ + "static/international-yards-desktop-9ea7e6e611a4200de8678ce67935a7fc.svg";